import {Component, OnInit, AfterViewInit, PLATFORM_ID, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {PaymentData} from 'src/app/models/application/payment-data.model';
import {DialogService} from 'src/app/services/dialog.service';
import {SessionService} from 'src/app/services/session.service';
import {Constants} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-fad-empresa',
    templateUrl: './fad-empresa.component.html',
    styleUrls: ['./fad-empresa.component.scss']
})
export class FadEmpresaComponent implements  OnInit {
    private userData: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    contactForm: any;

    constructor(
        private router: Router,
        private sessionService: SessionService,
        private dialogService: DialogService,
        private deviceService: DeviceDetectorService,
        @Inject(PLATFORM_ID) private platformId: any,
        @Inject(DOCUMENT) private document: any
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
        this.userData = this.sessionService.getPaymentAccount();
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {

            const ancla = sessionStorage.getItem('ancla');
            sessionStorage.removeItem('ancla');
            console.log(ancla)
            const scrollTo = ancla ? ancla : 'inicio';
        
            // Verificar si el elemento con el ID existe en el DOM
            const targetElement = this.document.getElementById(scrollTo);
              console.log(targetElement)
            if (targetElement) {
              setTimeout(() => {
                targetElement.scrollIntoView({
                  behavior: "instant",
                  block: "start",
                  inline: "nearest"
                });
              }, 300);
            }
          }
        this.addDataLayer();
    }



    addDataLayerEmpresas(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'MXN',
                add: {                                // 'add' actionFieldObject measures.
                    products: [{                        //  adding a product to a shopping cart.
                        name: 'FAD® Firma - Plan empresas - Suscripcion Mensual',
                        id: 'FADPESM',
                        price: '499',
                        brand: 'FAD®',
                        category: 'FAD® Empresas',
                        variant: 'Suscripcion Ilimitada',
                        position: 1
                    }]
                }
            }
        });
    }

    callForm(type, isAdd?: boolean): void {
        let data: PaymentData;
        switch (type) {
            case 3:
                if (this.sessionService.getCountryData()) {
                    data = {
                        product: 'FAD® EMPRESA',
                        subscription: 'Suscripción mensual',
                        quantity: 1,
                        type: 'month',
                        usuarios: 1,
                        usuariosLabel: 'Usuarios incluídos',
                        /* En lugar de mandar el mensaje de ilimitadas, cambie el texto por 1000*/
                        transactions: '1000',
                        transactionType: 'Video acuerdo + Video firma + Constancia de conservación',
                        pricing: 499,
                        pricingInfo: 'MXP',
                        complements: [...Constants.defaultComplements]
                    };
                } else {
                    data = {
                        product: 'FAD® EMPRESA',
                        subscription: 'Suscripción mensual',
                        quantity: 1,
                        type: 'month',
                        usuarios: 1,
                        usuariosLabel: 'Usuarios incluídos',
                        /* En lugar de mandar el mensaje de ilimitadas, cambie el texto por 1000*/
                        transactions: '1000',
                        transactionType: 'Video acuerdo + Video firma + Constancia de conservación',
                        pricing: 24.9,
                        pricingInfo: 'USD',
                        complements: [...Constants.defaultComplements]
                    };
                }
                if (this.userData === null) {
                    if (isAdd) {
                        this.sessionService.updateCartList(data, true);
                    } else {
                        const itemExist = this.sessionService.getCartItems().find(
                            item => item.product === data.product && item.subscription === data.subscription
                        );
                        if (itemExist) {
                            this.sessionService.setPaymentData(data);
                            this.router.navigate(['/comprar-firma-digital']);
                        } else {
                            if (this.sessionService.getCartItems().length === 0) {
                                this.sessionService.updateCartList(data, true);
                                this.sessionService.setPaymentData(data);
                                this.router.navigate(['/comprar-firma-digital']);
                            } else {
                                this.dialogService.showNotificationDialog('Ups!', ' No puedes combinar paquetes.');
                            }
                        }
                    }
                } else {
                    if (this.userData.isCompany === true) {
                        if (isAdd) {
                            this.sessionService.updateCartList(data, true);
                        } else {
                            const itemExist = this.sessionService.getCartItems().find(
                                item => item.product === data.product && item.subscription === data.subscription
                            );
                            if (itemExist) {
                                this.sessionService.setPaymentData(data);
                                this.router.navigate(['/comprar-firma-digital']);
                            } else {
                                this.sessionService.updateCartList(data, true);
                                this.sessionService.setPaymentData(data);
                                this.router.navigate(['/comprar-firma-digital']);
                            }
                        }
                    } else {
                        this.dialogService.showNotificationDialog('Tu cuenta es personal.', ' No puedes agregar este producto, necesitas una cuenta empresarial.');
                    }
                }
                this.addDataLayerEmpresas();
                break;
            case 4:
                this.contactForm = 4;
                const prepago = {
                    name: 'FAD® Firma - Plan empresas - Prepago por transacción con vigencia anual',
                    id: 'FADPEP',
                    price: '1',
                    variant: 'Prepago con vigencia anual',
                    position: '2'
                };
                this.addDataLayerClicProducto(prepago);
                break;
            case 5:
                this.contactForm = 5;
                const integraciones = {
                    name: 'FAD® Firma - Plan empresas - Integraciones especiales',
                    id: 'FADPEIE',
                    price: '1',
                    variant: 'API/SDK',
                    position: '3'
                };
                this.addDataLayerClicProducto(integraciones);
                break;
            case 8: 
            this.contactForm = 8;
                break;  
        }
        if (this.isMobile === true || this.isTablet === true) {
            document.querySelector('#contact-cotizar-movil').scrollIntoView();
        } else {
            document.querySelector('#contact-cotizar').scrollIntoView();
        }
    }

    addDataLayerClicProducto(item: any): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {
                        list: 'Search Results'
                    },
                    products: [{
                        name: item.name,
                        id: item.id,
                        price: item.price,
                        brand: 'FAD®',
                        category: 'FAD® Empresas',
                        variant: item.variant,
                        position: item.position
                    }]
                }
            }
        });
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'impressionView',
            ecommerce: {
                currencyCode: 'MXN',
                impressions: [
                    {
                        name: 'FAD® Firma - Plan empresas - Suscripcion Mensual',
                        id: 'FADPESM',
                        price: '499',
                        brand: 'FAD®',
                        category: 'FAD® Empresas',
                        variant: 'Suscripcion Ilimitada',
                        list: 'FAD® Firma - Plan Empresa',
                        position: 1
                    },
                    {
                        name: 'FAD® Firma - Plan empresas - Prepago por transacción con vigencia anual',
                        id: 'FADPEP',
                        price: '1',
                        brand: 'FAD®',
                        category: 'FAD® Empresas',
                        variant: 'Prepago con vigencia anual',
                        list: 'FAD® Firma - Plan Empresa',
                        position: 2
                    },
                    {
                        name: 'FAD® Firma - Plan empresas - Integraciones especiales',
                        id: 'FADPEIE',
                        price: '1',
                        brand: 'FAD®',
                        category: 'FAD® Empresas',
                        variant: 'API/SDK',
                        list: 'FAD® Firma - Plan Empresa',
                        position: 3
                    }
                ]
            }
        });
    }

}
